/* eslint-disable no-useless-escape,no-mixed-operators */
/* eslint-disable max-len */
import {
  validationValue,
  insertOrRemoveErrorFromList,
} from '../../../utils/strings';
import { findLocationByName } from '../../../utils/filters';
import { documentNumberError, nitCheckDigitError } from '../../../utils/documents';

/**
 * @param {{ documentType?: string, identificationNumber?: string }} documentContext opcional: con él
 * se valida el formato del documento (identificationNumber) y el dígito de verificación del NIT
 * (codeVerification)
 */
export const stepsValidation = (
  name,
  errorText,
  changes,
  errorsList,
  setErrorsList,
  locations,
  countryCode,
  documentContext,
) => {
  const temporalErrorsList = errorsList.slice();

  insertOrRemoveErrorFromList(
    temporalErrorsList,
    name,
    errorText,
    changes ? 'remove' : 'insert',
  );

  if (
    name === 'postalCode'
    || name === 'RFC'
    || name === 'email'
    || name === 'emailForBilling'
    || name === 'cellPhone'
    || name === 'address'
  ) {
    insertOrRemoveErrorFromList(
      temporalErrorsList,
      name,
      validationValue(changes, name).error,
      validationValue(changes, name).correct ? 'remove' : 'insert',
    );
  }

  if (changes && documentContext && name === 'identificationNumber') {
    const error = documentNumberError(documentContext.documentType, changes);
    insertOrRemoveErrorFromList(temporalErrorsList, name, error, error ? 'insert' : 'remove');
  }

  if (changes !== '' && changes !== null && changes !== undefined && documentContext && name === 'codeVerification') {
    const error = nitCheckDigitError(documentContext.identificationNumber, changes);
    insertOrRemoveErrorFromList(temporalErrorsList, name, error, error ? 'insert' : 'remove');
  }

  if (countryCode && countryCode === '170' && name === 'locationName') {
    const value = changes?.split('-');
    let location;

    if (value?.length > 1) {
      location = findLocationByName(value[0], value[1], locations);
    }

    insertOrRemoveErrorFromList(
      temporalErrorsList,
      name,
      'Ciudad no encontrada',
      location ? 'remove' : 'insert',
    );
  }

  setErrorsList(temporalErrorsList);
  return temporalErrorsList.length === 0;
};

const validateReceiverInfo = (receiverInfo, temporalErrorsList) => {
  const listToValidate = [
    {
      value: receiverInfo.receiverName,
      errorName: 'receiverName',
      errorText: 'Ingresa el nombre de quien recibe',
    },
    {
      value: receiverInfo.receiverLastName,
      errorName: 'receiverLastName',
      errorText: 'Ingresa el apellido de quien recibe',
    },
    {
      value: receiverInfo.receiverCellphone,
      errorName: 'receiverCellphone',
      errorText: 'Ingresa un número de celular',
    },
    {
      value: receiverInfo.destinationAddress,
      errorName: 'destinationAddress',
      errorText: 'Ingresa máximo 200 caracteres.',
    },
  ];

  listToValidate.map((item) => {
    insertOrRemoveErrorFromList(
      temporalErrorsList,
      item.errorName,
      item.errorText,
      validationValue(item.value, item.type).correct ? 'remove' : 'insert',
    );
    return null;
  });

  return listToValidate;
};

const validateReceiverCellphoneLength = (receiverInfo, temporalErrorsList) => {
  if (receiverInfo.receiverCellphone.length !== 10) {
    insertOrRemoveErrorFromList(
      temporalErrorsList,
      'receiverCellphone',
      'El número de celular debe tener 10 dígitos',
      receiverInfo.receiverCellphone.length === 10 ? 'remove' : 'insert',
    );
  }
};

const validateReceiverEmail = (receiverInfo, listToValidate) => {
  if (receiverInfo.receiverEmail) {
    listToValidate.push({
      value: receiverInfo.receiverEmail,
      errorName: 'receiverEmail',
      errorText: 'Ingresa un correo valido',
      type: 'email',
    });
  }
};

const validateDestinationAddressLength = (receiverInfo, listToValidate) => {
  if (receiverInfo.destinationAddress.length > 200) {
    listToValidate.push({
      value: receiverInfo.destinationAddress,
      errorName: 'destinationAddress',
      errorText: 'Ingresa máximo 200 caracteres.',
      type: 'destinationAddress',
    });
  }
};

const validateTakeToOfficeOrCollection = (
  receiverInfo,
  temporalErrorsList,
  listToValidate,
) => {
  if (receiverInfo.takeToOfficeOrCollection === 'takeToOffice') {
    listToValidate.push({
      value: receiverInfo.receiverDocumentNumber,
      errorName: 'receiverDocumentNumber',
      errorText: 'Ingresa el número de documento de quien recibe',
    });

    const removeReceiverAddress = temporalErrorsList
      .map((errorMessage) => errorMessage.name)
      .indexOf('destinationAddress');
    if (removeReceiverAddress > -1) temporalErrorsList.splice(removeReceiverAddress, 1);

    const removeGeolocationError = temporalErrorsList
      .map((errorMessage) => errorMessage.name)
      .indexOf('geolocationRequired');
    if (removeGeolocationError > -1) temporalErrorsList.splice(removeGeolocationError, 1);
  } else {
    listToValidate.push({
      value: receiverInfo.destinationAddress,
      errorName: 'destinationAddress',
      errorText: 'Ingresa una dirección de entrega',
    });

    const removeReceiverDocumentNumber = temporalErrorsList
      .map((errorMessage) => errorMessage.name)
      .indexOf('receiverDocumentNumber');
    if (removeReceiverDocumentNumber > -1) temporalErrorsList.splice(removeReceiverDocumentNumber, 1);
  }
};

export const stepTwoValidation = (
  countryCode,
  receiverInfo,
  errorsList,
  setErrorsList,
) => {
  const temporalErrorsList = errorsList.slice();

  const listToValidate = validateReceiverInfo(receiverInfo, temporalErrorsList);

  validateReceiverCellphoneLength(receiverInfo, temporalErrorsList);
  validateReceiverEmail(receiverInfo, listToValidate);
  validateDestinationAddressLength(receiverInfo, listToValidate);
  validateTakeToOfficeOrCollection(
    receiverInfo,
    temporalErrorsList,
    listToValidate,
  );

  if (
    countryCode === '170'
    || (countryCode === '484' && receiverInfo.receiverCellphone.length < 10)
  ) {
    insertOrRemoveErrorFromList(
      temporalErrorsList,
      'receiverCellphone',
      'El número de celular debe tener 10 dígitos',
      receiverInfo.receiverCellphone.length === 10 ? 'remove' : 'insert',
    );
  }

  // Validar que la dirección tenga coordenadas de georreferenciación cuando es entrega en dirección
  if (receiverInfo.takeToOfficeOrCollection === 'collectionInAddress') {
    const hasValidGeolocation = receiverInfo.destinyLatitude && receiverInfo.destinyLongitude;
    insertOrRemoveErrorFromList(
      temporalErrorsList,
      'geolocationRequired',
      'Debes seleccionar una dirección válida de las sugerencias',
      hasValidGeolocation ? 'remove' : 'insert',
    );

    // Validar que las instrucciones de entrega sean obligatorias
    insertOrRemoveErrorFromList(
      temporalErrorsList,
      'deliveryInstructions',
      'Las instrucciones de entrega son obligatorias',
      receiverInfo.deliveryInstructions && receiverInfo.deliveryInstructions.trim().length > 0 ? 'remove' : 'insert',
    );
  } else {
    // Remover el error de instrucciones de entrega si se selecciona entrega en oficina
    const removeDeliveryInstructionsError = temporalErrorsList
      .map((errorMessage) => errorMessage.name)
      .indexOf('deliveryInstructions');
    if (removeDeliveryInstructionsError > -1) temporalErrorsList.splice(removeDeliveryInstructionsError, 1);
  }

  setErrorsList(temporalErrorsList);

  return temporalErrorsList.length === 0;
};
